import './components/cards';

const heroBlock = document.querySelector('.hero-block');

if(heroBlock) {
    if(!heroBlock.classList.contains('shown')) {
            heroBlock.classList.add('shown');
    }
}

const ulMenu = document.querySelector('#main-menu');

if(ulMenu) {
    ulMenu.querySelectorAll('li').forEach(li => {
        li.classList.add('dropdown-item');
    });
}